/**
 * Icons for the work order history modal, one per kind of activity.
 * Colour is a prop so the same set can be reused outside the modal.
 */

/** Work Order created */
export const WoaCreatedSvg = ({ color = '#006CDD' }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M7.33333 14.6651H2.00003L2 2.33301H4.66669M10 2.33301H12.6667V9.33301" stroke="#006CDD" stroke-linecap="square" />
        <path
            d="M9.0013 1.33301H5.66797C5.11568 1.33301 4.66797 1.78072 4.66797 2.33301C4.66797 2.88529 5.11568 3.33301 5.66797 3.33301H9.0013C9.55357 3.33301 10.0013 2.88529 10.0013 2.33301C10.0013 1.78072 9.55357 1.33301 9.0013 1.33301Z"
            stroke="#006CDD"
            stroke-linecap="square"
        />
        <path d="M4.66797 9.99967H6.9537M4.66797 7.33301H10.0013" stroke="#006CDD" stroke-linecap="square" />
        <path d="M13.9987 11.333L10.6654 14.6663L9.33203 13.333" stroke="#006CDD" stroke-linecap="square" />
    </svg>
);

/** Work Order created from Estimate */
export const WoaCreatedFromEstimateSvg = ({ color = '#006CDD' }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
            d="M8.66797 1.99967V5.99967H12.668M2.66797 7.33301V1.33301H8.66797L13.3346 5.99967V14.6663H2.66797V12.6663"
            stroke="#006CDD"
            stroke-linecap="square"
        />
        <path d="M7.33464 8L9.33464 10L7.33464 12M9.0013 10H2.66797" stroke="#006CDD" stroke-linecap="square" />
    </svg>
);

/** Work Order edited */
export const WoaEditedSvg = ({ color = '#006CDD' }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M14 5.33333L10.6667 2L2.66667 10L2 14L6 13.3333L14 5.33333Z" stroke="#006CDD" stroke-linecap="square" />
        <path d="M9 4.33301L11.6667 6.99967" stroke="#006CDD" stroke-linecap="square" />
    </svg>
);

/** Customer authorization confirmed */
export const WoaAuthorizationConfirmedSvg = ({ color = '#006CDD' }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
            d="M14.6654 7.99967C14.6654 4.31777 11.6806 1.33301 7.9987 1.33301C4.3168 1.33301 1.33203 4.31777 1.33203 7.99967C1.33203 11.6815 4.3168 14.6663 7.9987 14.6663C11.6806 14.6663 14.6654 11.6815 14.6654 7.99967Z"
            stroke="#006CDD"
        />
        <path d="M5.33203 8.33333L6.9987 10L10.6654 6" stroke="#006CDD" />
    </svg>
);

/** Work Order reauthorized by customer after changes */
export const WoaReauthorizedSvg = ({ color = '#006CDD' }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M1.16797 7.58301L3.5013 9.91634L9.33464 4.08301" stroke="#006CDD" stroke-width="0.875" stroke-linecap="square" />
        <path d="M6.41797 9.33301L7.0013 9.91634L12.8346 4.08301" stroke="#006CDD" stroke-width="0.875" stroke-linecap="square" />
    </svg>
);

/** Work Order cancelled */
export const WoaCancelledSvg = ({ color = '#006CDD' }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
            d="M14.6654 7.99967C14.6654 4.31777 11.6806 1.33301 7.9987 1.33301C4.3168 1.33301 1.33203 4.31777 1.33203 7.99967C1.33203 11.6815 4.3168 14.6663 7.9987 14.6663C11.6806 14.6663 14.6654 11.6815 14.6654 7.99967Z"
            stroke="#006CDD"
            stroke-linecap="square"
        />
        <path d="M9.9996 10L6 6M6.00043 10L10 6" stroke="#006CDD" stroke-linecap="square" />
    </svg>
);

/** Authorization removed after Work Order edited */
export const WoaAuthorizationRemovedSvg = ({ color = '#006CDD' }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M11 5.33301H14V2.33301" stroke="#006CDD" stroke-linecap="square" />
        <path
            d="M2 8C2 4.68629 4.6862 2 8 2C10.5189 2 12.2563 3.29165 13.5506 5M14 8C14 11.3137 11.3138 14 8 14C5.48103 14 3.74365 12.7083 2.44938 11"
            stroke="#006CDD"
            stroke-linecap="square"
        />
        <path d="M5 10.667H2V13.667" stroke="#006CDD" stroke-linecap="square" />
    </svg>
);

/** Cancellation removed after Work Order edited — the client's artwork is the same pencil as "edited" */
export const WoaCancellationRemovedSvg = ({ color = '#006CDD' }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M14 5.33333L10.6667 2L2.66667 10L2 14L6 13.3333L14 5.33333Z" stroke="#006CDD" stroke-linecap="square" />
        <path d="M9 4.33301L11.6667 6.99967" stroke="#006CDD" stroke-linecap="square" />
    </svg>
);

/**
 * Invoice unlinked after Work Order changes.
 * NOTE: the artwork supplied is a 4×4 fragment (one corner of a broken-link mark), not a full
 * 16×16 icon, so it renders tiny. Replace with the complete export when available.
 */
export const WoaInvoiceUnlinkedSvg = ({ color = '#006CDD' }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
            d="M6.66797 8.81966C6.76237 8.97426 6.87444 9.12059 7.0041 9.25553C7.8091 10.0933 9.0361 10.2243 9.97303 9.64846C10.1466 9.54173 10.3102 9.41079 10.4594 9.25553L12.619 7.00793C13.5732 6.01489 13.5732 4.40483 12.619 3.41178C11.6648 2.41873 10.1178 2.41873 9.16364 3.41178L8.68797 3.90685"
            stroke="#006CDD"
            stroke-linejoin="round"
        />
        <path
            d="M7.31484 12.0933L6.83897 12.5885C5.88481 13.5816 4.33778 13.5816 3.3836 12.5885C2.42942 11.5955 2.42942 9.98546 3.3836 8.9924L5.54322 6.7448C6.49739 5.75174 8.04444 5.75173 8.99857 6.7448C9.12824 6.87966 9.24024 7.026 9.33464 7.18053"
            stroke="#006CDD"
            stroke-linejoin="round"
        />
        <path d="M14.0013 10.667H11.9487M10.668 14.0003V11.9477" stroke="#006CDD" stroke-linejoin="round" />
        <path d="M2 5.33333H4.05259M5.33333 2V4.05259" stroke="#006CDD" stroke-linejoin="round" />
    </svg>
);

/** Work Order PDF downloaded */
export const WoaPdfDownloadedSvg = ({ color = '#006CDD' }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
            d="M14 11.333V12.6663C14 13.4027 13.4031 13.9997 12.6667 13.9997H3.33333C2.59696 13.9997 2 13.4027 2 12.6663V11.333"
            stroke="#006CDD"
            stroke-linecap="square"
        />
        <path d="M5 7.66667L8.00003 10.6667L11 7.66667M8.00003 10V2" stroke="#006CDD" stroke-linecap="square" />
    </svg>
);

/** Work Order converted to Invoice */
export const WoaConvertedToInvoiceSvg = ({ color = '#006CDD' }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
        <path
            d="M13.3346 6.85645V1.33301L11.3346 2.33301L9.66797 1.33301L8.0013 2.33301L6.33464 1.33301L4.66797 2.33301L2.66797 1.33301V14.6663L4.66797 13.6663L6.33464 14.6663L8.0013 13.6663L9.66797 14.6663L11.3346 13.6663L13.3346 14.6663V13.6185"
            stroke="#006CDD"
            stroke-linecap="square"
        />
        <path d="M14.2852 8.57129L15.9994 10.2856L14.2852 11.9999M15.7137 10.2856H10.2852" stroke="#006CDD" stroke-linecap="square" />
        <path d="M5.33203 8H10.6654" stroke="#006CDD" stroke-linecap="square" />
        <path d="M5.33203 5.33301H7.9987" stroke="#006CDD" stroke-linecap="square" />
        <path d="M5.71484 10.2861H8.00056" stroke="#006CDD" stroke-linecap="square" />
    </svg>
);

/** Work Order email sent & resend */
export const WoaEmailSentSvg = ({ color = '#006CDD' }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M1.99609 6L13.9961 2L9.9961 14L7.7961 8.2L1.99609 6Z" stroke="#006CDD" stroke-linecap="square" stroke-linejoin="round" />
        <path d="M9.10547 6.88952L10.661 5.33398" stroke="#006CDD" stroke-linecap="square" />
    </svg>
);
